const ERROR_FIELD = 'Todos os campos precisam ser preenchidos.';
const ERROR_EMAIL = 'Necessário email válido.';
const ERROR_PASSWORD = 'O password deve ter no mínimo 6 dígitos.';
const INTERNAL_ERROR = 'Erro Interno, por favor tente mais tarde.'
const ERROR_TASK = 'Necessário preencher com uma nova tarefa.'

export {
  ERROR_FIELD,
  ERROR_EMAIL,
  ERROR_PASSWORD,
  INTERNAL_ERROR,
  ERROR_TASK,
};
